function Survey() {
    return (
        <div className="container" style={{marginTop: "100px"}}>
            <br/>
            <h2>Survey</h2>
            <p>The online survey is now closed. Thanks to everyone who participated!</p>
        </div>
    );
};

export default Survey;